import { render, staticRenderFns } from "./NewOrderFromHistory.vue?vue&type=template&id=4dfaba5c&scoped=true"
import script from "./NewOrderFromHistory.vue?vue&type=script&lang=js"
export * from "./NewOrderFromHistory.vue?vue&type=script&lang=js"
import style0 from "./NewOrderFromHistory.vue?vue&type=style&index=0&id=4dfaba5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfaba5c",
  null
  
)

export default component.exports